module.exports = __webpack_public_path__ + "static/media/Buggy ride.4924f008.webp";